<template>
  <header>
    <h2 class="text-2xl text-center">{{titleJa}}</h2>
    <h3 class="mt-4 text-orange text-center">{{titleEn}}</h3>
  </header>
</template>
<script>
export default {
  props: {
    titleJa: {
      default: ""
    },
    titleEn: {
      default: ""
    }
  }
};
</script>